import { addMinutes, formatISO } from 'date-fns';
// @ts-expect-error TS7016: Could not find a declaration file for module
import DashboardQuery from '../graphql/queries/dashboard.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestDetailQuery from '../graphql/queries/pullRequestDetail.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestsQuery from '../graphql/queries/pullRequests.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestsMetricsQuery from '../graphql/queries/pullRequestsMetrics.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import RepositoryListQuery from '../graphql/queries/repositoryList.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import CommitListQuery from '../graphql/queries/commitList.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import CommonIssuesQuery from '../graphql/queries/commonIssues.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import CommitDetailAllDataQuery from '../graphql/queries/commitDetailAllData.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import InstallWebhook from '../graphql/mutations/installWebhook.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import UpdateUserInfo from '../graphql/mutations/updateUserInfo.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import UpdateVcsAnnotations from '../graphql/mutations/updateVcsAnnotations.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import QuickFixPullRequestQuery from '../graphql/queries/quickFixPullRequest.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import GeneratePullRequestFromDiff from '../graphql/mutations/generatePullRequestFromDiff.graphql';
import BaseModel from './BaseModel';
import Dashboard from './entities/Dashboard';
import PullRequest from './entities/PullRequest';
import PullRequestList from './entities/PullRequestList';
import { timezoneOffsetCalculation } from '../utils/timezoneOffsetCalculation';
import PullRequestsMetricList from './entities/PullRequestMetricList';
import Repository from './entities/Repository';
import CommitList from './entities/CommitList';
import DefectList from './entities/DefectList';
import CommitCodeCoverage from './entities/CommitCodeCoverage';
import CommitDetail from './entities/CommitDetail';
import { replaceAsciiCharWithSlash } from '../utils/resolveBranch';
import QuickFixPullRequest from './entities/QuickFixPullRequest';
export default class ApiV2Model extends BaseModel {
    constructor(client) {
        super();
        this.client = client;
    }
    async updateUserInfo() {
        const { data } = await this.client.mutate({
            mutation: UpdateUserInfo,
            variables: {
                userInfo: {
                    skipTaskOrganisationInvite: true,
                },
            },
        });
        return data;
    }
    async installWebhook(repositoryId) {
        const result = await this.client.mutate({
            mutation: InstallWebhook,
            fetchPolicy: 'network-only',
            variables: {
                id: repositoryId,
            },
        });
        if (!result.data) {
            throw new Error(`Install webhook was unsucessful for the repository: ${repositoryId}`);
        }
        return new Dashboard(result.data.installWebhook);
    }
    async updateAnnotations(repositoryId, enable) {
        const { data } = await this.client.mutate({
            mutation: UpdateVcsAnnotations,
            variables: {
                request: {
                    id: repositoryId,
                    enable,
                },
            },
        });
        return data.status;
    }
    async getDashboard(vcs, repositoryFullname, branchName) {
        const variables = {
            fullname: repositoryFullname,
            vcs,
        };
        if (branchName) {
            variables.branchName = replaceAsciiCharWithSlash(branchName);
        }
        const { data } = await this.client.query({
            query: DashboardQuery,
            fetchPolicy: 'network-only',
            variables,
        });
        return new Dashboard(data.dashboard, branchName);
    }
    async getPullRequestDetail(repositoryId, prId) {
        const variables = {
            repositoryId,
            prId,
        };
        const { data } = await this.client.query({
            query: PullRequestDetailQuery,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            variables,
        });
        return new PullRequest(data.pullRequestDetail);
    }
    async getPullRequestList(repositoryIds, prIds) {
        const variables = {
            repositoryId: repositoryIds,
            ...(prIds?.length && { prIds }),
        };
        const { data } = await this.client.query({
            query: PullRequestsQuery,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            variables,
        });
        return new PullRequestList(data.pullRequests);
    }
    async getPullRequestMetrics(timezoneId, activeRepositoriesIds, from, to, pollInterval = 0) {
        const variables = {};
        if (activeRepositoriesIds && activeRepositoriesIds.length !== 0) {
            variables.repositoryIds = activeRepositoriesIds;
        }
        if (from) {
            variables.startDate = formatISO(addMinutes(from, timezoneOffsetCalculation(from, timezoneId)));
        }
        if (to) {
            variables.endDate = formatISO(addMinutes(to, timezoneOffsetCalculation(to, timezoneId)));
        }
        const { data } = await this.client.query({
            query: PullRequestsMetricsQuery,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            // eslint-disable-next-line no-undefined
            variables: Object.keys(variables).length ? variables : undefined,
            pollInterval,
        });
        return new PullRequestsMetricList(data.pullRequestsMetrics);
    }
    async getRepositoryList(reload) {
        const { data } = await this.client.query({
            query: RepositoryListQuery,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            variables: {
                reload,
            },
        });
        const repositoriesData = data.repositoryList;
        const repositories = repositoriesData.map((repository) => new Repository({
            ...repository,
            webhookLoading: false,
        }, {
            commits: [],
            currentPage: 1,
            moreCommits: false,
            limit: 10,
        }, {}));
        return repositories;
    }
    async getCommitList(branchId, lastTime = null) {
        const { data } = await this.client.query({
            query: CommitListQuery,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            variables: {
                branchId,
                ...(lastTime && { lastTime }),
            },
        });
        const commitData = data.commitList;
        return new CommitList(commitData.commits, commitData.limit, commitData.moreCommit, 1, {});
    }
    async getDefectList(commitHash, vcs, limit = 10, onlyNew = false, issuesType) {
        const { data } = await this.client.query({
            query: CommonIssuesQuery,
            fetchPolicy: 'network-only',
            variables: {
                commitHash,
                vcs,
                onlyNew,
                limit,
                ...(issuesType && { issuesType: issuesType.toUpperCase() }),
            },
        });
        const defectList = data.commonIssues;
        return new DefectList(defectList.commonIssues, defectList.totalNodes);
    }
    async getCommitDetailAllData(commitHash, vcs, onlyNew = false, issuesLimit, issuesType) {
        const { data } = await this.client.query({
            query: CommitDetailAllDataQuery,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            variables: {
                commitHash,
                vcs,
                onlyNew,
                ...(issuesLimit && { limit: issuesLimit }),
                ...(issuesType && { issuesType: issuesType.toUpperCase() }),
            },
        });
        return {
            commitCodeCoverage: new CommitCodeCoverage(data.commitCodeCoverage),
            commitDetail: new CommitDetail(data.commitDetail, data.commonIssues.commonIssues),
            defectList: new DefectList(data.commonIssues.commonIssues, data.commonIssues.totalNodes),
        };
    }
    async getQuickFixesForPullRequest(commitHash, vcs) {
        const { data } = await this.client.query({
            query: QuickFixPullRequestQuery,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            variables: {
                commitHash,
                vcs,
            },
        });
        return new QuickFixPullRequest(data.quickFixPullRequest);
    }
    async generatePullRequestFromDiff(variables) {
        const files = variables.files.map((file) => {
            return {
                fixTool: file.fixTool,
                path: file.path,
            };
        });
        const { data } = await this.client.mutate({
            mutation: GeneratePullRequestFromDiff,
            fetchPolicy: 'network-only',
            variables: {
                request: {
                    ...variables,
                    files,
                },
            },
        });
        return data;
    }
}
